import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "isStacked", "children", "color", "date", "direction", "maxWidth", "shouldTruncateText", "status", "time", "isWithCheckmark", "checkmarkAccessibilityLabel", "UNSAFE_containerProps"];
import React from 'react';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import ActionIconCheckmark from '@bubble-ui/icon-action-checkmark';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { isNative } from '@bubble-ui/util-platform';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var ChatBubble = function ChatBubble(_ref) {
  var id = _ref.id,
    isStacked = _ref.isStacked,
    children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'gray' : _ref$color,
    date = _ref.date,
    direction = _ref.direction,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? 260 : _ref$maxWidth,
    _ref$shouldTruncateTe = _ref.shouldTruncateText,
    shouldTruncateText = _ref$shouldTruncateTe === void 0 ? false : _ref$shouldTruncateTe,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'read' : _ref$status,
    time = _ref.time,
    isWithCheckmark = _ref.isWithCheckmark,
    checkmarkAccessibilityLabel = _ref.checkmarkAccessibilityLabel,
    UNSAFE_containerProps = _ref.UNSAFE_containerProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var ids = getIds(id);
  var designContext = useDesignContext(defaultDesignTokens);
  var designVersion = useDesignVersion();
  var styles = getDefaultStyleSheet({
    color: color,
    date: date,
    direction: direction,
    designContext: designContext,
    designVersion: designVersion,
    isStacked: isStacked,
    maxWidth: maxWidth,
    shouldTruncateText: shouldTruncateText,
    status: status
  });
  return /*#__PURE__*/React.createElement(View, _extends({}, UNSAFE_containerProps, {
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    style: styles.mainStyle
  }, props), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.background,
    style: styles.backgroundStyle
  }, /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: shouldTruncateText ? 1 : 0
  } : {}, {
    tag: "paragraph",
    style: styles.paragraphSecondaryCorrectFootprintBlockStyle
  }), children)), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.timestamp,
    style: styles.timestampStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.timestampMainStyle
  }, date && /*#__PURE__*/React.createElement(View, {
    style: styles.timestampDateViewStyle
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.timestampDateTextStyle
  }, date)), time && /*#__PURE__*/React.createElement(View, {
    style: styles.timestampTimeStyle
  }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: shouldTruncateText ? 1 : 0
  } : {}, {
    tag: "paragraph",
    style: styles.paragraphQuaternaryCorrectFootprintDarkGrayStyle
  }), time)), isWithCheckmark && /*#__PURE__*/React.createElement(View, {
    style: styles.timestampCheckmarkStyle
  }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(ActionIconCheckmark, {
    accessibilityLabel: checkmarkAccessibilityLabel,
    colorToken: "chat-bubble/timestamp-date-text-color"
  }))))));
};
ChatBubble.displayName = 'ChatBubble';
export default withProvisionalOverrideFromContext(ChatBubble);
//# sourceMappingURL=index.js.map